import React, { BaseSyntheticEvent } from 'react';
import clsx from 'clsx';
import {
    Popover,
    MenuItem as MaterialMenuItem,
    Typography,
    IconButton,
    useTheme,
} from '@material-ui/core';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { useStyle } from './theme-nested-menu-styles';
import { MenuItem } from './theme-nested-menu';

export interface ThemeNestedMenuItemProps {
    item?: MenuItem;
    isDisabled?: boolean;
    closePopup?: () => void;
}

export const ThemeNestedMenuItem = (props: ThemeNestedMenuItemProps): JSX.Element => {
    const classes = useStyle();
    const theme = useTheme();

    const { item, isDisabled, closePopup } = props;

    const handleAdditionalAction = (e: BaseSyntheticEvent, cb: () => void): void => {
        e.stopPropagation();
        cb();
    };

    return (
        <PopupState variant='popover'>
            {(popupState) => {
                return (
                    <div>
                        <MaterialMenuItem
                            disabled={isDisabled}
                            className={classes.menuItem}
                            style={{
                                backgroundColor:
                                    item.isActive && theme.palette.info.light,
                            }}
                            {...bindTrigger(popupState)}
                        >
                            <Typography
                                variant='inherit'
                                className={classes.menuItemText}
                            >
                                {item.title}
                            </Typography>
                            {item.icon ? (
                                <IconButton
                                    size='small'
                                    onClick={(e: BaseSyntheticEvent) =>
                                        handleAdditionalAction(e, item.additionalAction)
                                    }
                                    className={clsx(
                                        classes.additionalActive,
                                        item.isAdditionalActionActive
                                            ? classes.additionalActionActive
                                            : null
                                    )}
                                >
                                    {item.icon}
                                </IconButton>
                            ) : null}
                            <ArrowForwardIosIcon />
                        </MaterialMenuItem>
                        <Popover
                            {...bindPopover(popupState)}
                            elevation={2}
                            anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            className={classes.itemsContainer}
                        >
                            {item.nestedMenu.map((item: MenuItem) =>
                                !item.nestedMenu ? (
                                    <MaterialMenuItem
                                        disabled={isDisabled}
                                        key={item.title}
                                        className={classes.menuItem}
                                        onClick={() => {
                                            item.action();
                                            popupState.close();
                                            if (closePopup) {
                                                closePopup();
                                            }
                                        }}
                                        style={{
                                            backgroundColor:
                                                item.isActive && theme.palette.info.light,
                                        }}
                                    >
                                        <Typography
                                            variant='inherit'
                                            className={classes.menuItemText}
                                        >
                                            {item.title}
                                        </Typography>
                                        {item.icon ? (
                                            <IconButton
                                                size='small'
                                                onClick={(e: BaseSyntheticEvent) =>
                                                    handleAdditionalAction(
                                                        e,
                                                        item.additionalAction
                                                    )
                                                }
                                                className={clsx(
                                                    classes.additionalActive,
                                                    item.isAdditionalActionActive
                                                        ? classes.additionalActionActive
                                                        : null
                                                )}
                                            >
                                                {item.icon}
                                            </IconButton>
                                        ) : null}
                                    </MaterialMenuItem>
                                ) : (
                                    <ThemeNestedMenuItem
                                        key={item.title}
                                        item={item}
                                        isDisabled={isDisabled}
                                    />
                                )
                            )}
                        </Popover>
                    </div>
                );
            }}
        </PopupState>
    );
};
